module.exports = __webpack_public_path__ + "img/p11.d6c4a6f2.svg";